export interface AboutSection {
  title: string;
  paragraphs: string[];
  bullets?: string[];
}

export const aboutCopyEn = {
  title: 'About Portcierge',
  lead:
    'Portcierge is a local-first cruise organizer on phone and on the web. It brings your day-by-day sailing itinerary together with weather, quick capture, and optional AI planning—without turning your cruise into a spreadsheet.',
  sections: [
    {
      title: 'On phone and on the web',
      paragraphs: [
        'Plan your sailing on a big screen at home, then take the same cruise—ports, days, weather, and options—with you on your phone when you’re aboard or ashore.',
        'Your trip stays continuous wherever you open Portcierge, so planning and underway don’t live in separate places.',
      ],
    },
    {
      title: 'What you can plan',
      paragraphs: [
        'Create cruises with embarkation, sea days, and port calls. Portcierge generates the days for your sailing so planning stays consistent as your itinerary changes.',
      ],
      bullets: [
        'Cruise itineraries with embarkation, sea days, and port dates',
        'A day view with weather, scheduled items, notes, and “tonight’s accommodation”',
        'Per-port “Options” lists for shore-excursion ideas and checklists',
        'Hotel and pre/post-cruise stay management by city',
        'Country info reference screens (visa/embassy/currency/tipping and more)',
      ],
    },
    {
      title: 'Weather that stays useful',
      paragraphs: [
        'Weather forecasts are fetched for your ports and cached locally. Portcierge can also infer planning alerts (like storms, heat, wind, or heavy rain) based on forecast patterns.',
      ],
    },
    {
      title: 'Optional AI features',
      paragraphs: [
        'If you enable AI features, Portcierge can generate a port-day plan (highlights + time-blocked itinerary suggestions) and help extract structured cruise details from items you share into the app.',
        'AI is designed to be “review first”: you choose what gets added to your cruise.',
      ],
    },
    {
      title: 'Share into the app',
      paragraphs: [
        'On iOS, use the Share Sheet to send URLs, text, PDFs, and files into Portcierge. Items land in a Shared Items inbox where you can process, review, and save them into the right cruise and port.',
      ],
    },
    {
      title: 'Privacy and data model',
      paragraphs: [
        'Portcierge is local-first: your trip data is stored on your device. Network calls are used for weather, AI (when enabled), and optional community/location sharing features (when enabled).',
      ],
    },
  ] satisfies AboutSection[],
} as const;
